/**
 * Ontology object — the canonical addressable unit in the registry. Plan §26.7.
 *
 * `canonicalKey` shape: `{kind}/{jurisdiction}/{family}/{ruleId}`.
 * `state` advances via ReviewDecision; never mutate in place.
 * `payload` is intentionally `z.record(z.unknown())` — each `objectKind` has
 *   its own typed payload that lives in the specific schema file. This object
 *   is the storage envelope, not the typed payload itself.
 */

import { z } from "zod";
import { ReviewTransitionState } from "./primitives";

export const OntologyObjectKind = z.enum([
  "rule",
  "evidence",
  "card",
  "signal",
  "snapshot",
]);
export type OntologyObjectKind = z.infer<typeof OntologyObjectKind>;

export const OntologyObjectSchema = z.object({
  objectId: z.string().min(1),
  objectKind: OntologyObjectKind,
  canonicalKey: z.string().min(1),
  state: ReviewTransitionState,
  version: z.number().int().positive(),
  parentObjectId: z.string().optional(),
  payload: z.record(z.unknown()),
  contractVersion: z.string(),
  schemaVersion: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type OntologyObject = z.infer<typeof OntologyObjectSchema>;
